<template>

    <div class="">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-4" style="margin-top: 2%;">
                <img src="@/assets/integrations/customers/banco_del_bajio.png" alt="Banco del Bajío" width="200">
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-md-2"></div>
            <div class="col-md-8">
                <div class="rounded p-3" style="height: 450px; overflow-y: hidden;">
                    <div class="input-group flex-nowrap">
                        <div class="btn bg-dark" style="width: 25%; vertical-align: middle;">
                            <!-- <span class="cato-main-color fs-1">PaloAlto</span>
                            <br>
                            <span class="cato-main-color fs-6" >Networks</span> -->
                            <img src="@/assets/integrations/brands/paloalto.png" alt="Palo Alto" width="200">
                        </div>


                        <!-- Inicia el Meú de Vistas  -->
                        <div class="bg-black border border-dark rounded p-2"
                            style="width: 75%; align-items: center; display:flex;">
                            <button v-if="alias[s]" class="btn btn-dark fs-2 me-1" data-bs-toggle="modal"
                                data-bs-target="#fully" @click="setHeader(s)" v-for="(s, i) in sections" :key="i">
                                {{ alias[s].alias || "Sin Alias para este cliente (Dev-Mode)"  }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Main Dashboard -->
        <div class="modal fade" id="fully" tabindex="-1">
            <div class="modal-dialog modal-fullscreen">
                <div class="modal-content" :class="[light.body]">
                    <div class="modal-header border-0">
                        <div class="input-group flex-nowrap">
                            <div class="btn rounded me-1" :class="[light.back, light.border]"
                                style="width: 30%; pointer-events: none;">

                                <!-- <span class="cato-main-color fw-bold" style="font-size: 45px;">PaloAlto</span>
                                <div class="cato-main-color fw-bold" style="font-size: 15px; margin-top: -15px;">Networks</div> -->
                                <img src="@/assets/integrations/brands/paloalto.png" alt="Palo Alto" width="200">

                            </div>
                            <div class="btn rounded input-group me-1" :class="[light.back, light.border]"
                                style="width: 70%; pointer-events:none;">
                                <div v-if="modal != null" class="w-100 fw-bold mt-2" style="font-size: 24px;"
                                    :class="[light.text]">{{ alias[modal].header }}</div>
                                <div class="w-100 mt-2" :class="[light.text]">{{ timestamp != null ? timestamp : '-' }}</div>
                            </div>
                            <div class="rounded p-2 me-1" :class="[light.back, light.border]" style="width: 20%;">
                                <button class="btn bg-gradient rounded" style="width: 100%;" :class="[light.button]"
                                    @click="refresh();" :disabled="loading || timing">
                                    <i class="fa-solid fa-xl fa-refresh" :class="{ 'fa-spin': loading }"></i>
                                </button>
                                <div v-if="!timing" class="input-group flex-nowrap mt-1" :class="{ 'disabled': loading }">
                                    <select class="btn bg-gradient me-1 fs-6" style="width: 50%;"
                                        :class="[light.button]" v-model="startime" title="Automatic update time.">
                                        <option :value="120">2</option>
                                        <option :value="180">3</option>
                                        <option :value="300">5</option>
                                    </select>
                                    <button class="btn bg-gradient fs-6" style="width: 50%;" :class="[light.button]"
                                        @click="startTimer();">
                                        <i class="fa-solid fa-xl fa-clock-rotate-left"></i>
                                    </button>
                                </div>
                                <div v-if="timing" class="input-group flex-nowrap mt-1">
                                    <div class="btn fa-fade" :class="[light.button]" style="width: 50%;">
                                        {{ `${Math.floor(counter / 60)}:${counter % 60 < 10 ? '0' + counter % 60 : counter % 60}`
                                            }} </div>
                                            <button class="btn btn-danger rounded fs-6" style="width: 50%;"
                                                @click="stopTimer();">
                                                <i class="fa-solid fa-xl fa-stop"></i>
                                            </button>
                                    </div>
                                </div>
                                <div class="btn rounded input-group me-1" :class="[light.back, light.border]"
                                    style="width: 10%;">
                                    <button class="btn btn-danger text-white rounded w-100 mb-1"
                                        title="Close dashboard." data-bs-dismiss="modal">
                                        <i class="fa-solid fa-xl fa-close"></i>
                                    </button>
                                    <button class="btn rounded w-100" :class="[light.toggle, light.border]"
                                        @click="setMode()">
                                        <i class="fa-solid fa-xl" :class="[light.icon]"></i>
                                    </button>
                                </div>
                                <div class="btn rounded me-1" :class="[light.back, light.border]"
                                    style="pointer-events:none; width: 30%;">
                                    <img src="@/assets/integrations/customers/banco_del_bajio.png" alt="Banco del Bajío"
                                        width="140">
                                </div>
                            </div>
                        </div>


                        <div class="modal-body border-0 border-top" :class="[light.border_top]"
                            style="overflow-y: scroll;">
                            <div v-if="modal == 'paloalto-level-1'" :class="{ 'fa-fade loading': loading }">
                                <Paloalto1 :light="light" :mapkey="mapkey" :site="site" ref="paloalto-level-1"
                                    @clear-loading-lv1="clearLoading"></Paloalto1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>


</template>

<script>
    // @ is an alias to /src

    import Level1 from '@/components/apps-components/integrations/customers/sigma/sections/Level1.vue'
    import Level2 from '@/components/apps-components/integrations/customers/sigma/sections/Level2.vue'
    import External1 from '@/components/apps-components/integrations/customers/sigma/sections/External1.vue'
    import Paloalto1 from '@/components/apps-components/integrations/customers/banco_del_bajio/sections/Level1.vue'


    import axios from "axios";

    export default {
        name: 'Sigma-Main',
        props: {
            site: String,
            sections: Array
        },
        components: {
            // Level1,
            // Level2,
            // External1,
            Paloalto1
        },
        data() {
            return {
                alias: {
                    // Names
                    // "cato-level-1": {header:"Operational Dashboard - L1", alias: "Level 1"},
                    // "cato-level-2": {header:"Operational Dashboard - L2", alias: "Level 2"},
                    // "cato-external": {header:"Operational Dashboard - External", alias: "External"},
                    "paloalto-level-1": { header: "Operational Dashboard - PaloAlto", alias: "Palo Alto" }
                },
                loading: false,
                section: null,
                modal: null,
                lightmode: 'night',
                // Classes
                light: {
                    text: null,
                    button: null,
                    back: null,
                    body: null,
                    border: null
                },
                day: {
                    text: "text-black",
                    button: "btn-success",
                    back: "bg-white",
                    body: "bg-white",
                    border: "border border-light-grey",
                    border_top: "border-top border-light-grey",
                    border_bottom: "border-bottom border-light-grey",
                    header: "",
                    icon: "fa-moon",
                    toggle: "btn-white text-black",
                    theme: "general"
                },
                night: {
                    text: "text-white",
                    button: "btn-dark",
                    back: "bg-dark",
                    body: "bg-black",
                    border: "border border-dark",
                    border_top: "border-top border-dark",
                    border_bottom: "border-bottom border-dark",
                    header: "bg-dark",
                    icon: "fa-sun",
                    toggle: "btn-warning",
                    theme: "dark"
                },
                timestamp: null,
                mapkey: null,
                // Timer
                timing: false,
                timerID: null,
                startime: 120,
                counter: 30
            }
        },
        methods: {
            getMapkey() {
                const params = {}
                const dest = this.site + '/integrations/main/mapkey'
                axios
                    .get(dest, { params })
                    .then(rx => {
                        // Code
                        this.mapkey = rx.data.key
                    })
                    .catch(error => {
                        //this.processErrorMessage(error)
                    });
            },
            refresh() {
                this.loading = true
                setTimeout(() => { this.$refs[this.section].getMaindata(); }, 200);
            },
            clearLoading(timestamp) {
                this.timestamp = timestamp
                this.loading = false
            },
            setMode() {
                if (this.lightmode == 'day') {
                    this.lightmode = 'night'
                    this.light = this.night
                }
                else if (this.lightmode == 'night') {
                    this.lightmode = 'day'
                    this.light = this.day
                }
                this.renderMap(this.section)
            },
            setHeader(section) {
                this.section = section
                this.modal = section
                this.timestamp = null
                // this.renderMap(section)
                this.refresh()
            },
            renderMap(section) {
                //   setTimeout(() => { this.$refs[section].renderMap(); }, 200);
            },
            titlelize(_string) {
                return _string.toLowerCase()
                    .split('-')
                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                    .join('-');
            },
            // Timer
            startTimer() {
                console.log('Timer...')
                this.counter = this.startime
                this.timerID = setInterval(this.timer, 1000);
                this.timing = true
            },
            stopTimer() {
                clearInterval(this.timerID);
                this.timing = false
            },
            timer() {
                this.counter--
                if (this.counter == 0) {
                    this.refresh()
                    this.counter = this.startime
                }
            }
        },
        created: function () {
            this.light = this.night
            this.getMapkey()
        },
        mounted: function () {
            // Code
            //
        }

    }
</script>

<style scoped>

    .cato-main-color {
        color: rgb(67, 139, 108);
    }

    .border-light-grey {
        border: solid rgb(146, 146, 146) 1px
    }

    .border-bottom-light-grey {
        border-bottom: solid rgb(146, 146, 146) 1px
    }

    .disabled {
        pointer-events: none;
        opacity: 0.2;
    }

    .loading-div {
        opacity: 0.5;
        pointer-events: none;
    }

</style>